import { FormattedMessage } from 'react-intl';

import messages from '../../messages';

const name = <FormattedMessage {...messages.connectionSkuColumnHeader} />;

/**
 * @param {object} data - Row data
 * @returns {string} Connection SKU value
 */
const render = (data) => data?.connectionSku ?? '';

export default {
  getMessageDescriptor: () => messages.connectionSkuColumnHeader,
  name,
  render,
};
